import gql from 'graphql-tag';

import dropboxRemoteItemsPageFragment from '../fragments/dropboxRemoteItemsPageFragment';

export const queryDropboxRemoteItemsPage = gql`
  query dropboxRemoteItemsPage(
    $credentialID: DokkioID!
    $parentFolderRemoteID: String
    $cursor: String
  ) {
    dropboxRemoteItemsPage(
      credentialID: $credentialID
      parentFolderRemoteID: $parentFolderRemoteID
      cursor: $cursor
    ) {
      ...dropboxRemoteItemsPageFragment
    }
  }
  ${dropboxRemoteItemsPageFragment}
`;

export default queryDropboxRemoteItemsPage;
